import gql from "graphql-tag";

export default gql`
  mutation SignInWithGoogleOAuthIdToken($idToken: String!, $timeZone: String!, $utms: UTMParametersInput) {
    signInWithGoogleOAuthIdToken(idToken: $idToken, timeZone: $timeZone, utms: $utms) {
      email
      isRecentlyCreatedUser
      accessToken
    }
  }
`;
